<template>
	<div class="w-full">
		<vs-row vs-justify="center">
			<vs-col  vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="12" vs-sm="12" class="text-left">
				<vs-row>
					<vs-col class="mb-6 md:mb-0" vs-justify="center" vs-align="center" vs-w="6" vs-sm="12" vs-lg="6">
					   <Number
					   	v-model="questionsByPage[index].properties.min"
					   	:label="$t('MODULE.optionMinimas')" :min="miniRequired"
					   	:max="maxi"
					   	@blur="validateMin"/>
					</vs-col>
					<vs-col vs-justify="center" vs-align="center" vs-w="6" vs-sm="12" vs-lg="6">
					   <Number
					   	v-model="questionsByPage[index].properties.max"
					   	:label="$t('MODULE.optionMaximas')"
					   	:min="mini"
					   	:max="lengthOptions"
					   	@blur="validateMax"/>
					</vs-col>
				</vs-row>
			</vs-col>
		</vs-row>
		<h6 class="vs-input--label mb-3 mt-5">{{$t('MODULE.addOptionsTolist')}}</h6>
		<Options :index="index"></Options>
	</div>
</template>
<script type="text/javascript">
import mixins from "../mixsCommons/MultiandMultiOther"

export default {
    mixins: [mixins]
}

</script>
